import { ActionTypes } from "./constants";

const toggleVisible = (visible, title, width, content) => ({ type: ActionTypes.TOGGLE_VISIBLE, payload: {visible, title, width, content}});
const toggleVisible2 = (visible2, title2, width2, content2) => ({ type: ActionTypes.TOGGLE_VISIBLE2, payload: {visible2, title2, width2, content2}});

const exportedObject = { 
    toggleVisible,
    toggleVisible2
};

export default exportedObject
